enum SortingDirection {
    Asc = 'Asc',
    Desc = 'Desc',
}

export default SortingDirection;
